import { useEffect } from 'react';
import { Breadcrumbs } from 'react-daisyui';
import { Helmet } from 'react-helmet';
import { useMatches } from 'react-router-dom';
import { TRouteLoaderData } from '../../types/commonTypes';
import { documentTitleFromMatches } from '../../utils/helpers/routeTitle';

interface IAppHeadingWithBreadcrumbsProps {
  hasBreadcrumbs?: boolean;
  initialCrumb?: string;
  isInternal?: boolean;
  onResetWorkspace?: () => void;
  workspaceName?: string;
}

/**
 * @deprecated Use `Breadcrumb` from `@sr/ui-library`
 */
const AppHeadingWithBreadcrumbs = ({
  hasBreadcrumbs,
  initialCrumb,
  isInternal,
  onResetWorkspace,
  workspaceName,
}: IAppHeadingWithBreadcrumbsProps) => {
  const matches = useMatches();

  const pageTitle = documentTitleFromMatches(matches, initialCrumb);

  // Filter the matches to those which contain loader data.title property
  const crumbs = matches.filter((match) => {
    const data = match.data as TRouteLoaderData;

    if (data && data.title) return true;
  });

  useEffect(() => {
    if (!matches[matches.length - 1].params.workspaceId) onResetWorkspace?.();
  }, [matches, onResetWorkspace]);

  // Pop the last crumb off the array to use as the main heading title
  const title = crumbs.pop();

  // Pop again to remove the current page
  // Base from the number 10 comment
  // https://screenrights.atlassian.net/browse/APP-408?focusedCommentId=22724
  crumbs.pop();

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <div className="flex items-center gap-5">
        <div className="flex flex-[1_0_0] flex-col items-start gap-0.5">
          <div className="truncate text-nowrap font-sans text-lg font-bold !leading-normal text-white lg:text-2xl">
            {(title?.data as TRouteLoaderData)?.title}
          </div>
          {hasBreadcrumbs && (
            <Breadcrumbs className="hidden p-0 text-sm font-normal !leading-normal text-white opacity-50 lg:inline-block">
              <>
                {initialCrumb && (
                  <Breadcrumbs.Item>{initialCrumb}</Breadcrumbs.Item>
                )}
                {workspaceName && isInternal ? (
                  <Breadcrumbs.Item>{workspaceName}</Breadcrumbs.Item>
                ) : (
                  crumbs.map((crumb) => (
                    <Breadcrumbs.Item key={crumb.id}>
                      {(crumb.data as TRouteLoaderData)?.title}
                    </Breadcrumbs.Item>
                  ))
                )}
              </>
            </Breadcrumbs>
          )}
        </div>
      </div>
    </>
  );
};

export default AppHeadingWithBreadcrumbs;
